<template>
  <div class="app-container">
    <el-card v-if="form">
      <div class="back-box">
        <div @click="handleBack">
          <img src="../../../assets/back.png" alt="" />
          <span>返回</span>
        </div>
      </div>
      <div class="title-box"><span class="txt1">治疗师</span></div>
      <el-descriptions>
        <el-descriptions-item label="姓名">{{rowItem.customerName}}</el-descriptions-item>
        <el-descriptions-item label="身份">{{rowItem.customerLevel}}</el-descriptions-item>
        <el-descriptions-item label="手机号码">{{rowItem.customerPho}}</el-descriptions-item>
      </el-descriptions>
      <div class="title-box"><span class="txt1">档案信息</span></div>
      <el-descriptions>
        <el-descriptions-item label="姓名">{{form.name}}</el-descriptions-item>
        <el-descriptions-item label="手机号">{{form.pho}}</el-descriptions-item>
        <el-descriptions-item label="性别">{{form.sex === 1?'男':(form.sex === 2?'女':'')}}</el-descriptions-item>
        <el-descriptions-item label="年龄">{{form.age}}</el-descriptions-item>
        <el-descriptions-item label="病名">{{form.diseaseName}}</el-descriptions-item>
        <el-descriptions-item label="建档时间">{{formatTime(form.createdTime)}}</el-descriptions-item>
      </el-descriptions>
      <div class="title-box"><span class="txt1">皮肤情况</span></div>
      <div class="treatment-box">
        <div v-if="form.skinPicUrl && form.skinPicUrl.split(',').length > 0" class="mirror-section">
          <div class="mirror-label">皮肤镜：</div>
          <el-image class="banner-box" fit="contain" v-for="(item,index) in form.skinPicUrl.split(',')" :key="index" :src="item" :preview-src-list="[item]"></el-image>
        </div>
        <div v-if="form.woodsLampUrl && form.woodsLampUrl.split(',').length > 0" class="mirror-section">
          <div class="mirror-label">伍德镜：</div>
          <el-image class="banner-box" fit="contain" v-for="(item,index) in form.woodsLampUrl.split(',')" :key="index" :src="item" :preview-src-list="[item]"></el-image>
        </div>
      </div>
      <div class="title-box"><span class="txt1">检查报告</span></div>
      <div class="treatment-box">
        <el-image class="banner-box" fit="contain" v-for="(item,index) in form.inspectionReportUrl && form.inspectionReportUrl.split(',')" :key="index" :src="item" :preview-src-list="[item]"></el-image>
      </div>
    </el-card>
  </div>
</template>

<script>
import userArchivesApi from '@/api/archives/userArchives'
export default {
  props: ['rowItem',],
  data() {
    return {
      form: {},
    }
  },
  created() {
    this.getDeatils()
  },
  methods: {
    getDeatils() {
      userArchivesApi.fetchById(this.rowItem.id).then(res => {
        let data = res.data;
        this.form = data
      })
    },
    handleBack() {
      this.$emit('handleShow', '', 1)
    },
    /**
     * 格式化时间，去掉T字符
     */
    formatTime(timeStr) {
      if (!timeStr) return ''
      return timeStr.replace('T', ' ')
    },
  }

}
</script>

<style lang="scss" scoped>
.banner-box {
  width: 200px;
  height: 150px;
  margin: 2px;
}
.custom {
  font-size: 14px;
  color: #2e2f3e;
  padding: 20px;
  margin: 10px 0;
  &.bg {
    // border-bottom: 1px solid #CCE2D1
    background-color: #eff8fd;
  }
}
.title-box {
  margin: 10px 24px 15px 0;
  &::after {
    content: '';
    display: table;
    clear: both;
  }
  .txt1 {
    font-size: 16px;
    // font-weight: bold;
    color: #000000;
    position: relative;
    padding-left: 5px;
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 3px;
      bottom: 0;
      width: 4px;
      background: #5dbde7;
      border-radius: 6px;
    }
  }
  .txt2 {
    font-size: 12px;
    color: #8f8e8e;
    padding-left: 7px;
  }
  .fr {
    float: right;
    font-size: 16px;
    color: #1596cd;
  }
}
.tab-box {
  margin-bottom: 40px;
  span {
    font-size: 16px;
    color: #000000;
    cursor: pointer;
    padding-right: 48px;
    &.active {
      color: #5dbde7;
    }
  }
}
.oppr-btn {
  text-align: right;
  margin-bottom: 20px;
}
.treatment-box {
  margin-bottom: 14px;
  .mirror-section {
    margin-bottom: 20px;
    .mirror-label {
      font-size: 14px;
      font-weight: bold;
      color: #333;
      margin-bottom: 10px;
    }
  }
  .tdesc {
    font-size: 14px;
    color: #606266;
    padding-bottom: 12px;
    &.w2 {
      width: 49%;
      display: inline-block;
    }
  }
  .record-item {
    font-size: 14px;
    color: #606266;
    padding: 12px 8px;
    background: #fff;
    margin-bottom: 5px;
    width: 480px;
    span {
      color: #4680e3;
      cursor: pointer;
      float: right;
    }
  }
}
</style>
